import React from "react";
import ProductGenericSkeleton from "./ProductGenericSkeleton";

function ProductDetailSkeleton() {
  return (
    <>
      <ProductGenericSkeleton />
    </>
  );
}

export default ProductDetailSkeleton;
